<app-header></app-header>
<div class='govpl-spacer'></div>
<main>
  <div>
    <section class='gov-services blue-bar-row blue-bar-row--epolak'>
      <div class='main-container'>
        <div class='blue-bar'>
          <div class='blue-bar-content'>
            <h2>Załatwiaj sprawy urzędowe</h2>
            <span class='subheader'>przez internet, bezpiecznie i wygodnie!</span>
            <form class='search-form' [formGroup]='form' (submit)='onSearch()' novalidate>
              <input formControlName='query' placeholder='Szukaj usług'
                     aria-label='Wpisz nazwę do wyszukania. Naciśnij TAB aby przejść do przycisku.'>
              <button type='submit'>
                <span class='sr-only'>Wyszukaj</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <section class='gov-services'>
      <div class='main-container'>
        <div class='tabs-container'>
          <div>
            <ul id='services-tabs' role='tablist'>
              <li>
                <a #servicesTab id='services-tab' data-toggle='tab' href='#'
                   (click)="$event.preventDefault(); activeTab = servicesTab" role='tab'
                   aria-controls='services' aria-selected='true' [ngClass]="{ active: activeTab === servicesTab }">
                  Usługi
                </a>
              </li>
              <li>
                <a #mapTab id='map-tab' data-toggle='tab' href='#'
                   (click)="$event.preventDefault(); activeTab = mapTab" role='tab'
                   aria-controls='map' aria-selected='false' [ngClass]="{ active: activeTab === mapTab }">
                  Mapa
                </a>
              </li>
              <li>
                <a #appTab id='APP-tab' data-toggle='tab' href='#'
                   (click)="$event.preventDefault(); activeTab = appTab" role='tab'
                   aria-controls='APP' aria-selected='false' [ngClass]="{ active: activeTab === appTab }">
                  APP
                </a>
              </li>
            </ul>
          </div>
        </div>
        <br>
        @if (activeTab === servicesTab) {
          <div id='services' class='tab-content' aria-labelledby='services-tab'>
            <ul>
              @for (item of services(); track $index) {
                @if (($index < 12) && !item.isCaseRelated) {
                  <li>
                    <a [routerLink]='"/e-uslugi" + item.url'>
                      <img src='/img/icons/services/13-pismo-ogolne-do-urzedu.svg' alt=''>
                      <span>{{ item.name }}</span>
                    </a>
                  </li>
                }
              }
            </ul>
            <div class='center-buttons'>
              <a class='see-more-button btn btn-secondary' routerLink='/e-uslugi'>
                Zobacz wszystkie usługi
              </a>
            </div>
          </div>
        }
        @if (activeTab === mapTab) {
          <div id='map' class='tab-content active' aria-labelledby='map-tab'>
            <ul>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Mapa ogólna</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6NSwiem9vbSI6MiwiY2VudGVyIjpbNjQ0NDc1Ni4yOTkzMDkzODgsNTY3MzA5Mi40MDI5NTQ5ODVdLCJsYXllcnMiOlsiZWdpYl9kemlhbGtpIiwiZWdpYl9idWR5bmtpIiwiZWdpYl9ncmFuaWNlX2dtaW55IiwibXZfZHppYWxraV9tcHpwX3RhYmxlIiwibXB6cF9yZWplc3RyX29ib3dpYXp1amFjeV92aWV3IiwibXB6cF9wdW5rdHlfb2Jvd2lhenVqYWN5X3ZpZXciLCJtcHpwX2xpbmllX29ib3dpYXp1amFjeV92aWV3IiwibXB6cF9zdHJlZnlfb2Jvd2lhenVqYWN5X3ZpZXciLCJtcHpwX3ByemV6bmFjemVuaWFfb2Jvd2lhenVqYWN5X3ZpZXciLCJPcGVuU3RyZWV0TWFwIl0sInByb2plY3Rpb24iOiJFUFNHOjIxNzcifQ%3D%3D">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>MPZP</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6Nywiem9vbSI6MiwiY2VudGVyIjpbNjQ0NDc1Ni4yOTkzMDkzODgsNTY3MzA5Mi40MDI5NTQ5ODVdLCJsYXllcnMiOlsiZWdpYl9kemlhbGtpIiwiZWdpYl9vYnJlYnkiLCJlZ2liX2dyYW5pY2VfZ21pbnkiLCJzdWtpenBfa2llcnVua2lfcGt0Iiwic3VraXpwX2tpZXJ1bmtpX2xpbmllIiwic3VraXpwX2tpZXJ1bmtpX3BvdyIsInN1a2l6cF9raWVydW5raSIsIk9wZW5TdHJlZXRNYXAiXSwicHJvamVjdGlvbiI6IkVQU0c6MjE3NyJ9">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Studium</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6NCwiem9vbSI6MiwiY2VudGVyIjpbNjQ0NDc1Ni4yOTkzMDkzODgsNTY3MzA5Mi40MDI5NTQ5ODVdLCJsYXllcnMiOlsib3N3aWV0bGVuaWVfdWxpY3puZSIsImVnaWJfZHppYWxraSIsImVnaWJfb2JyZWJ5IiwiZWdpYl9ncmFuaWNlX2dtaW55IiwiZ2VzdXQiLCJPcGVuU3RyZWV0TWFwIl0sInByb2plY3Rpb24iOiJFUFNHOjIxNzcifQ%3D%3D">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Infrastruktura</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6MTAsInpvb20iOjIsImNlbnRlciI6WzY0NDQ3NTYuMjk5MzA5Mzg4LDU2NzMwOTIuNDAyOTU0OTg1XSwibGF5ZXJzIjpbImlud2VzdHljamVfYmV6cGllY3plbnN0d29fdmlldyIsImlud2VzdHljamVfZHJvZ2lfdmlldyIsImlud2VzdHljamVfa2FuYWxpemFjamFfdmlldyIsImlud2VzdHljamVfa3ViYXR1cmFfdmlldyIsImlud2VzdHljamVfb3N3aWV0bGVuaWVfdmlldyIsImlud2VzdHljamVfc3BvcnRfdmlldyIsImlud2VzdHljamVfd2lhdHlfcHJ6eXN0YW5rb3dlX3ZpZXciLCJlZ2liX2J1ZHlua2kiLCJlZ2liX2dyYW5pY2VfZ21pbnkiLCJPcGVuU3RyZWV0TWFwIl0sInByb2plY3Rpb24iOiJFUFNHOjIxNzcifQ%3D%3D">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Inwestycje</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6Niwiem9vbSI6MiwiY2VudGVyIjpbNjQ0NDc1Ni4yOTkzMDkzODgsNTY3MzA5Mi40MDI5NTQ5ODVdLCJsYXllcnMiOlsid3ljaW5raV9kcnpldyIsImVnaWJfZHppYWxraSIsImVnaWJfb2JyZWJ5IiwiZWdpYl9ncmFuaWNlX2dtaW55IiwiT3BlblN0cmVldE1hcCJdLCJwcm9qZWN0aW9uIjoiRVBTRzoyMTc3In0%3D">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Ochrona środowiska</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6Niwiem9vbSI6MiwiY2VudGVyIjpbNjQ0NDc1Ni4yOTkzMDkzODgsNTY3MzA5Mi40MDI5NTQ5ODVdLCJsYXllcnMiOlsid3ljaW5raV9kcnpldyIsImVnaWJfZHppYWxraSIsImVnaWJfb2JyZWJ5IiwiZWdpYl9ncmFuaWNlX2dtaW55IiwiT3BlblN0cmVldE1hcCJdLCJwcm9qZWN0aW9uIjoiRVBTRzoyMTc3In0%3D">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Gospodarka komunalna</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoportal/?permalink=eyJ0aGVtYXRpY01hcCI6MTUsInpvb20iOjIsImNlbnRlciI6WzY0NDQ3NzUuMjYwNjQ5MzEsNTY3MzA4My4wODA3NzUxOTldLCJsYXllcnMiOlsia29tdW5pa2FjamFfc3RhY2plX2tvbGVqb3dlIiwia29tdW5pa2FjamFfcHJ6eXN0YW5raSIsImtvbXVuaWthY2phX3RyYXNhXzkxIiwia29tdW5pa2FjamFfdHJhc2FfOTIiLCJrb211bmlrYWNqYV90cmFzYV85MyIsImtvbXVuaWthY2phX3RyYXNhXzk0Iiwia29tdW5pa2FjamFfdHJhc2FfOTUiLCJrb211bmlrYWNqYV90cmFzYV85MDQiLCJrb211bmlrYWNqYV90cmFzYV85MTEiLCJrb211bmlrYWNqYV90cmFzYV85MTQiLCJrb211bmlrYWNqYV90cmFzYV85MjEiLCJrb211bmlrYWNqYV90cmFzYV85MjgiLCJrb211bmlrYWNqYV90cmFzYV85MzAiLCJrb211bmlrYWNqYV90cmFzYV85MzEiLCJrb211bmlrYWNqYV90cmFzYV85NDEiLCJrb211bmlrYWNqYV90cmFzYV85NDQiLCJrb211bmlrYWNqYV90cmFzYV85NjEiLCJrb211bmlrYWNqYV90cmFzYV85NjQiLCJlZ2liX2R6aWFsa2kiLCJlZ2liX2J1ZHlua2kiLCJlZ2liX29icmVieSIsImVnaWJfZ3JhbmljZV9nbWlueSIsIk9wZW5TdHJlZXRNYXAiXSwicHJvamVjdGlvbiI6IkVQU0c6MjE3NyJ9">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Transport i komunikacja</span>
                </a>
              </li>
              <li>
                <a target="_blank"
                   title="Link jest otwierany w nowej zakładce przeglądarki"
                   href="https://dlugoleka.grobonet.com/">
                  <img aria-hidden="true" src="/img/icons/map-marker.svg" alt="">
                  <span>Cmentarze</span>
                </a>
              </li>
            </ul>
          </div>
        }
        @if (activeTab === appTab) {
          <div id='APP' class='tab-content active' aria-labelledby='APP-tab'>
            <p class="mb-2">
              MPZP - Adresy usług:
            </p>
            <ol class="ms-3 mb-4">
              <li>
                <app-label label="WMS:"><a
                  href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/mpzp/wms?service=WMS&request=GetCapabilities">https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/mpzp/wms?service=WMS&request=GetCapabilities</a>
                </app-label>
              </li>
              <li>
                <app-label label="WFS:"><a
                  href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/mpzp/wfs?service=WFS&request=GetCapabilities">https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/mpzp/wfs?service=WFS&request=GetCapabilities</a>
                </app-label>
              </li>
            </ol>
            <p class="mb-2">
              Studium - Adresy usług:
            </p>
            <ol class="ms-3 mb-4">
              <li>
                <app-label label="WMS:"><a
                  href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/studium/wms?service=WMS&request=GetCapabilities">https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/studium/wms?service=WMS&request=GetCapabilities</a>
                </app-label>
              </li>
              <li>
                <app-label label="WFS:"><a
                  href="https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/studium/wfs?service=WFS&request=GetCapabilities">https://geoportal.euslugi.gmina.dlugoleka.pl/geoserver/studium/wfs?service=WFS&request=GetCapabilities</a>
                </app-label>
              </li>
            </ol>
            <form #mpzpSearchForm="ngForm">
              <div class="row">
                <div class="col-md-6">
                  <div class='form-group'>
                    <label for='mpzpSearch'>
                      Wyszukaj
                    </label>
                    <input
                      [(ngModel)]="mpzpSearch"
                      id='mpzpSearch'
                      name="mpzpSearch"
                      placeholder='Wpisz tu numer uchwały / datę lub nazwę'
                      type='text'>
                  </div>
                </div>
              </div>
            </form>
            <ul>
              @for (item of mpzpRegisterData() || [] | filterData: mpzpSearch : false : 'tag'; track $index) {
                <li>
                  <p>
                    <strong>
                      Nr uchwały:
                    </strong>
                    {{ item.resolution_number || '-' }}
                  </p>
                  <p>
                    <strong>
                      Data uchwały:
                    </strong>
                    {{ item.resolution_date || '-' }}
                  </p>
                  <p>
                    <strong>
                      Nazwa:
                    </strong>
                    {{ item.name || '-' }}
                  </p>
                  <p>
                    <strong>
                      Załączniki:
                    </strong>
                    <a style="font-weight: normal"
                       class="d-inline-block"
                       title="Link otwiera się w nowej zakładce przeglądarki"
                       target="_blank"
                       [href]="item.resolution"
                       download>
                      Uchwała
                    </a>,
                    <a style="font-weight: normal"
                       class="d-inline-block"
                       title="Link otwiera się w nowej zakładce przeglądarki"
                       target="_blank"
                       [href]="item.raster"
                       download>
                      Raster
                    </a>,
                    <a style="font-weight: normal"
                       title="Link otwiera się w nowej zakładce przeglądarki"
                       class="d-inline-block"
                       target="_blank"
                       [href]="item.legend"
                       download>
                      Legenda
                    </a>,
                    <a style="font-weight: normal"
                       title="Link otwiera się w nowej zakładce przeglądarki"
                       class="d-inline-block"
                       target="_blank"
                       [href]="item.app"
                       download>
                      APP
                    </a>
                  </p>
                </li>
              }
            </ul>
            @if (!(mpzpRegisterData() || [] | filterData: mpzpSearch : false : 'tag').length) {
              <app-alert [closable]="false">Brak wynników</app-alert>
            }
          </div>
        }
      </div>
    </section>
  </div>
</main>
<app-footer></app-footer>
